import VerticalScene from "../../components/VerticalScene";

export default function Claim(){
    document.title = "玩心奥利奥元宇宙";
    return(
        <VerticalScene />
    );
}
